import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import("@/components/index.vue"),
    },
    {
      path: '/page1',
      name: '/page1',
      component: () => import("@/components/page1.vue"),
    },
    {
      path: '/page2',
      name: '/page2',
      component: () => import("@/components/page2.vue"),
    },
    {
      path: '/page3',
      name: '/page3',
      component: () => import("@/components/page3.vue"),
    }
  ],
  mode:'history'
})
